/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { ImageBlock } from "src/classes/block/block-types";

import { EditableCaption } from "./EditableCaption";

interface Props {
  editable: boolean;
  block: ImageBlock;
}

export function Caption({ editable, block }: Props) {
  return (
    <>
      {editable ? (
        <EditableCaption block={block} />
      ) : (
        <ReadOnlyCaption>{<div style={{ overflow: "hidden" }}>{block.snapshot.caption}</div>}</ReadOnlyCaption>
      )}
    </>
  );
}

const ReadOnlyCaption = styled.span`
  position: absolute;
  left: 3px;
  bottom: 3px;
  background: rgba(225, 225, 225, 0.85);
  font-size: 14px;
  font-family: Inter;
  padding-left: 3px;
  padding-right: 3px;
  border: 1px solid black;
  max-width: 80%;
  font-family: "IBM Plex Sans", sans-serif;
  white-space: nowrap;
`;
